import { useEffect } from 'react'
import _ from 'lodash'
import usePrevious from 'hooks/usePrevious'
import { sagaActions } from '../sagas'
import { useDispatch } from 'react-redux'
import useInterval from 'hooks/useInterval'

export default function useBoardsBlockerCount (boardIds) {
  const dispatch = useDispatch()

  const prevBoardIds = usePrevious(boardIds)

  useEffect(() => {
    if (boardIds.length > 0) {
      if (prevBoardIds) {
        const diffBoardIds = _.difference(boardIds, prevBoardIds)

        if (diffBoardIds.length > 0) {
          dispatch(sagaActions.fetchBoardsBlockerCount({
            boardIds: diffBoardIds
          }))
        }
      } else {
        if (boardIds.length > 0) {
          dispatch(sagaActions.fetchBoardsBlockerCount({
            boardIds
          }))
        }
      }
    }
  }, [boardIds])

  useInterval(() => {
    if (boardIds.length > 0) {
      dispatch(sagaActions.fetchBoardsBlockerCount({
        boardIds
      }))
    }
  }, 60000) // 1 minute
}
